<template>
  <div class="hub-section" :class="{large}" @click="buttonAction">

    <div class="hub-section__icon-holder">
      <svgicon class="hub-section__icon" :src="icon" v-if="icon" :height="large ? 75 : 60" :width="large ? 75 : 60"></svgicon>
    </div>

    <div class="hub-section__content-holder">
      <div class="hub-section__title" v-html="title"></div>
      <div class="hub-section__separator"></div>
      <div class="hub-section__description" v-html="description" v-if="description"></div>

      <button class="btn btn-primary">
        <svgicon src="icon/arrow-right-line.svg" :height="15" :width="15"></svgicon>
        {{buttonText || $t('access')}}
      </button>
    </div>


  </div>
</template>

<script>
  export default {
    name: "HubSection",

    props: {
      icon: String,
      title: String,
      large: Boolean,
      description: String,
      buttonText: String,
      buttonAction: Function
    }
  }
</script>

<style lang="scss" scoped>
  .hub-section {
    border-radius: 32px;
    display: flex;
    align-self: stretch;
    overflow: hidden;
    background: linear-gradient(to bottom, #fff 49%, #f5f5f5 50%);;
    min-height: 230px;
    flex-basis: 31%;
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.16);
    margin-bottom: 25px;
    cursor: pointer;

    &.large {
      flex-basis: 470px;
      min-height: 270px;

      .hub-section__icon-holder {
        padding: 32px;
      }
      .hub-section__title {
        font-size: 28px;
      }
    }
  }
  .hub-section__content-holder {
    background-color: white;
    padding: 32px;
    border-bottom-left-radius: 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }
  .hub-section__icon-holder {
    background-color: #f5f5f5;
    padding: 24px;
    border-top-right-radius: 32px;
  }
  .hub-section__title {
    font-size: 20px;
    font-weight: 900;
    color: #404040;
    margin-bottom: 10px;
  }
  .hub-section__description {
    font-size: 14px;
    color: #808080;
    flex-grow: 1;
  }
  .hub-section__separator {
    height: 4px;
    width: 40px;
    background-color: #e6e6e6;
    flex-shrink: 0;
    margin-bottom: 12px;
  }
  .btn {
    margin-top: 30px;
    padding: 10px 18px;
    border-radius: 6px;
    font-size: 14px;
    display: flex;
    align-items: center;
    .svgicon {
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 800px) {
    #app .hub-section {
      height: auto;
      margin-bottom: 20px;

      .hub-section__title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 8px;
      }
      .hub-section__description {
        font-size: 12px;
      }
      .btn {
        margin-top: 20px;
        border-radius: 20px;
      }

      &:not(.large) {
        flex-basis: 45%;
        .hub-section__icon-holder {
          display: none;
        }
        .hub-section__content-holder {
          padding: 24px 16px 16px 16px;
          text-align: center;
          align-items: center;
        }
        .btn {
          width: 100%;
          align-items: center;
          justify-content: center;
        }
      }

      &.large {
        height: auto;

        .hub-section__icon-holder {
          padding: 24px;
        }
        .hub-section__content-holder {
          padding: 24px 24px 16px 24px;
        }
        .separator {
          margin-bottom: 8px;
        }
      }
    }
  }
</style>